export const approximationTypes = {
    0: {
        key: 0,
        title: 'Арпс',
        checked: true,
        color: '#89AF4C',
    },
    1: {
        key: 1,
        title: 'Гипербола',
        checked: true,
        color: '#FFAE63',
    },
    2: {
        key: 2,
        title: 'Гиперболический закон',
        checked: true,
        color: '#2163FF',
    },
    3: {
        key: 3,
        title: 'Гомерперц',
        checked: true,
        color: '#BC814A',
    },
    4: {
        key: 4,
        title: 'Дробно-рациональная',
        max: 0,
        min: 0,
        checked: false,
        color: '#8768E5',
    },
    5: {
        key: 5,
        title: 'Линейная',
        checked: false,
        color: '#FF5252',
    },
    6: {
        key: 6,
        title: 'Кубагушев',
        checked: false,
        color: '#FFC107',
    },
    7: {
        key: 7,
        title: 'Логарифмическая',
        checked: false,
        color: '#AD4CAF',
    },
    8: {
        key: 8,
        title: 'Обобщенный полином',
        max: 0,
        min: 0,
        checked: false,
        color: '#4C9DAF',
    },
    9: {
        key: 9,
        title: 'Полиминальный',
        max: 0,
        checked: false,
        color: '#E9F64D',
    },
    10: {
        key: 10,
        title: 'Ревенко',
        checked: false,
        color: '#5720CC',
    },
    11: {
        key: 11,
        title: 'Ряд Фурье',
        harmonicsNumber: 0,
        checked: false,
        color: '#A674D9',
    },
    12: {
        key: 12,
        title: 'Стасенков',
        checked: false,
        color: '#A7E542',
    },
    13: {
        key: 13,
        title: 'Степенная',
        checked: false,
        color: '#AB9D20',
    },
    14: {
        key: 14,
        title: 'Экспоненциальная',
        checked: false,
        color: '#CC6820',
    },
};
